import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_12: FaireProductEntity = {
  token: "atc_refined_moma_12",
  type: "product",
  name: "Italian Design Cup Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c595f3dee0f9c06f47b751e8e75a9008eb8d70872bf1fb07d1d8a29df87c29fe.webp",
  priceDollars: 40,
  msrpDollars: 66,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
